import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });

export const money = (n, cur = "INR") =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: cur || "INR", maximumFractionDigits: 0 }).format(n || 0);

export const instantOff = (fare, cfg) => Math.max(0, Math.min(cfg?.instant_discount || 0, (fare || 0) - (cfg?.min_fare || 0)));

export const time = (iso) => (iso ? iso.slice(11, 16) : "");
export const dur = (m) => `${Math.floor(m / 60)}h ${String(m % 60).padStart(2, "0")}m`;
export const dateLabel = (iso, opts = { weekday: "short", day: "numeric", month: "short" }) =>
  iso ? new Date(iso.length === 10 ? iso + "T00:00:00" : iso).toLocaleDateString("en-IN", opts) : "";
export const ymd = (d) => {
  const z = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
  return z.toISOString().slice(0, 10);
};

export const AIRLINE_COLORS = {
  "6E": ["#0F2888", "#FFFFFF"], AI: ["#E31837", "#FFFFFF"], QP: ["#FF6B00", "#FFFFFF"],
  SG: ["#ED1C24", "#FDB913"], IX: ["#C8102E", "#F5A800"], EK: ["#D71921", "#FFFFFF"],
  SQ: ["#1D3C78", "#F0AB00"], QR: ["#5C0632", "#FFFFFF"], ZZ: ["#111827", "#FFFFFF"],
};

export const errMsg = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return fallback;
};

export const CABINS = [
  { id: "economy", label: "Economy" },
  { id: "premium_economy", label: "Premium Economy" },
  { id: "business", label: "Business" },
  { id: "first", label: "First" },
];

export const STATUS = {
  pending_payment: { label: "Awaiting payment", cls: "bg-amber-100 text-amber-700" },
  payment_submitted: { label: "Payment under verification", cls: "bg-blue-100 text-blue-700" },
  payment_rejected: { label: "Payment not received", cls: "bg-red-100 text-red-600" },
  payment_verified: { label: "Paid · ticket being issued", cls: "bg-indigo-100 text-indigo-700" },
  confirmed: { label: "Confirmed", cls: "bg-[#E8F5E9] text-[#0F9D58]" },
  ticketed: { label: "Ticket issued", cls: "bg-[#E8F5E9] text-[#0F9D58]" },
  cancel_requested: { label: "Cancellation requested", cls: "bg-orange-100 text-orange-700" },
  cancelled: { label: "Cancelled", cls: "bg-slate-200 text-slate-600" },
};

export const StatusBadge = ({ status }) => {
  const s = STATUS[status] || { label: status, cls: "bg-slate-100" };
  return <span data-testid="status-badge" className={`text-[11px] font-bold uppercase tracking-wider rounded-full px-2.5 py-1 ${s.cls}`}>{s.label}</span>;
};

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const login = () => window.dispatchEvent(new Event("open-login"));

export const googleLogin = () => {
  const redirectUrl = window.location.origin + window.location.pathname + window.location.search;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};
